const checkProgressWidth = () => {
  const shippingProgressBars = document.querySelectorAll('.free-shipping-indicator__progress-bar-inner');

  shippingProgressBars.forEach((shippingProgressBar) => {
    shippingProgressBar.classList.toggle('is-small', parseFloat(shippingProgressBar.style.width) < 15);
    const observer = new MutationObserver(checkProgressWidth);

    observer.observe(shippingProgressBar, { attributes: true });
  });
};

window.addEventListener('load', checkProgressWidth);
